import { render, staticRenderFns } from "./reNumberScur.vue?vue&type=template&id=97978164&scoped=true"
import script from "./reNumberScur.vue?vue&type=script&lang=js"
export * from "./reNumberScur.vue?vue&type=script&lang=js"
import style0 from "./reNumberScur.vue?vue&type=style&index=0&id=97978164&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97978164",
  null
  
)

export default component.exports